var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderShapes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1062 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #47bad1;\n      }\n\n      .st0, .st1, .st2, .st3 {\n        isolation: isolate;\n        opacity: .4;\n      }\n\n      .st1 {\n        fill: #b0c600;\n      }\n\n      .st4 {\n        fill: #fff;\n      }\n\n      .st5 {\n        mask: url(#mask);\n      }\n\n      .st6 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: #2855a2;\n      }\n\n      .st3 {\n        fill: #a55896;\n      }\n\n      .st7 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    width: 1062,
    height: 111,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -0.8,
    y: 21,
    width: 1062,
    height: 111,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1064,132H2V21h1062v111Z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1061,116.9l1.7,51.2c0,2.4-1.6,4.5-3.9,5l-182.4,40.3c-1.6.3-3.2,0-4.4-1.1l-94.1-83.8c-1.5-1.3-2-3.4-1.4-5.2l12.8-40.2c.5-1.5,1.7-2.7,3.2-3.2l168.5-55.1c1.7-.6,3.6-.1,5,1.1l93.5,87.6c1,.9,1.5,2.2,1.6,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,124.1l-3.7,60.4c-.1,2.4,1.4,4.6,3.8,5.2l209.3,52.6c1.6.4,3.2,0,4.4-1l112.6-94.6c.9-.8,1.5-1.8,1.7-3l16.6-98.2c.5-2.9-1.7-5.7-4.7-5.8L72.3,24.5c-1.8,0-3.4.7-4.4,2.2L3.8,121.6c-.5.7-.8,1.6-.8,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M811.3,105.8l-156.7-19.2c-1.6-.2-3.2.4-4.3,1.6l-65.5,72.5c-3,3.3-.5,8.6,4,8.3l224.6-13.8c2.8-.2,4.9-2.5,4.7-5.3l-2.4-39.5c-.1-2.4-2-4.4-4.4-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.5,63.3l140.5,169.5c2,2.4,1.3,6-1.4,7.6l-220.8,124.5c-2.4,1.4-5.4.5-6.8-1.9l-125.3-223.7c-1.5-2.7-.2-6.2,2.7-7.2l205.6-70.4c2-.7,4.1,0,5.4,1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.5,65.7l203.9,54.8c3,.8,4.6,4.2,3.2,7l-104.4,220.5c-1.2,2.5-4.2,3.6-6.7,2.4l-221.9-105.8c-2.8-1.3-3.7-4.9-1.9-7.5l122.4-169.5c1.2-1.7,3.3-2.4,5.3-1.9Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderShapes);
export default __webpack_public_path__ + "static/media/header_shapes.d9096f1b6f68b029b92ff51be7e5cc94.svg";
export { ForwardRef as ReactComponent };